import { useTranslation } from 'react-i18next';

import { Dialog, Text } from '~/components';

import type { AdvantageSimulationDialogProps as Props } from './AdvantageSimulationDialog.types';

import { AdvantageSimulationChart } from './AdvantageSimulationChart';
import { noDataDisclaimerStyle } from './AdvantageSimulationDialog.css';

export const AdvantageSimulationDialog = ({ calculationData }: Props) => {
  const { t } = useTranslation(['invoices']);

  return (
    <Dialog.Body>
      <Dialog.Header title={t('invoices:createEdit.advantageSimulationModal.title')} />

      {calculationData.advantageWithCs && calculationData.advantageWithoutCs && calculationData.coExclVat > 0 ? (
        <AdvantageSimulationChart calculationData={calculationData} />
      ) : (
        <Text className={noDataDisclaimerStyle}>{t('invoices:createEdit.advantageSimulationModal.noDataDisclaimer')}</Text>
      )}
    </Dialog.Body>
  );
};
